import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { PlaceholderChildComponent } from '@ispm/layout/classes/placeholder-child-component.abstract';
import { Observable, Subject } from 'rxjs';
import { EmitType } from '@ispm/layout/constants/emit-types.enum';
import { Filter } from '../../classes/filter';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/dynamic-form/constants/ItemsTypes';
import { FilterService } from '../../services/filter.service';
import { FilterActionCreatorService } from '../../services/filter-action-creator.service';
import { ConfirmModalComponent } from '@ispm/layout/components/modals/confirm-modal/confirm-modal.component';
import { ConfirmModalLoaderPayload } from '@ispm/layout/classes/confirm-modal-loader-payload';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { filter, finalize, flatMap, map } from 'rxjs/operators';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { NOTIFICATION_MESSAGE } from '@ispm-client/modules/aggregator/services/consts';
import { cloneDeep } from 'lodash';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Component({
  selector: 'gen-manage-filter',
  templateUrl: './manage-filter.component.html',
  styleUrls: ['./manage-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManageFilterComponent extends PlaceholderChildComponent implements OnInit {
  public dynamicFormConfig: DynamicFormItem[] =  [
    DynamicFormItem.builder('', 'name', ITEMS_TYPES.TEXT), // .setEditable(false)
    DynamicFormItem.builder('', 'creationDate', ITEMS_TYPES.DATEPICKER).setEditable(false)
  ];
  public payload: {
    filters: Filter[];
    isManageTitle: boolean;
    isManageDialog: boolean;
    selectedFilter: string;
    title: string;
    resourceTitle?: string;
  };
  public selectedFilter: any;
  public tunnel$: Subject<any>;

  private filters: Filter[];
  private changedFilters: boolean[];

  constructor(
    private notificationMessageService: NotificationMessageService,
    private notificationMessage: NOTIFICATION_MESSAGE,
    private filterService: FilterService,
    private filterAC: FilterActionCreatorService,
    private popupLoader: DynamicModalLoaderService,
    private changeDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    if (!this.payload.resourceTitle) {
      this.payload.resourceTitle = 'Filter';
    }

    if (this.payload.selectedFilter !== undefined) {
      this.selectedFilter = this.payload.selectedFilter;
      super.ngOnInit();
    }

    this.filters = this.payload.filters && this.payload.filters.map(filterObj => filterObj) || [];
    this.changedFilters = this.filters.map(_ => false);
    this.tunnel$.asObservable().pipe(
      filter(value => <any> value.emitter !== 'child')
    ).subscribe(next => {
      next.value && this.submit();
    });
  }

  submit() {
    this.changedFilters.forEach((filterObj, index) => filterObj && this.updateManagedFilter(index, this.filters[index]));
  }

  updateForm(filterIndex: number, filterObj: Filter) {
    this.filters[filterIndex] = cloneDeep(filterObj);
    this.changedFilters[filterIndex] = true;
  }

  updateButtonStatus(event: any) {
    this.tunnel$.next({
      value: EmitType.Data,
      payload: { approveBtn: !(this.selectedFilter.length > 0)}
    });
  }

  updateManagedFilter(filterIndex: number, filterObj: Filter) {
    // Call the filter-panel to update the filter name in the database
    // and in the filters list UI dropdown list.
    this.filterService.updateManagedFilter(filterObj)
      .pipe(
        filter(data => !!data),
        finalize(() => this.tunnel$.next({ emitter: 'child', value: EmitType.Dismiss }))
      )
      .subscribe(
        (res) => {
          this.filterAC.setAppliedFilter(res[0]);
          this.callback(<Filter> res[0]);
          this.payload.filters[filterIndex] = filterObj;
          this.notificationMessageService.success(`${this.payload.resourceTitle} ${this.notificationMessage.UPDATED_SUCCESSFULLY}`);
        },
        () => {
          this.notificationMessageService.error(
            `${this.notificationMessage.FAILED_TO_UPDATE} ${this.payload.resourceTitle.toLowerCase()} : ${filterObj.name}`
          );
        },
        () => this.changeDetector.markForCheck()
      );
  }

  deleteManagedFilter(filterIndex: number, event?: any) {
    // Call the filter-panel to delete the filter from the database
    // and from the filters list UI dropdown list.
    this.popupLoader.popupModal(ConfirmModalComponent,
      new ConfirmModalLoaderPayload('Delete ' + this.payload.resourceTitle, `Are you sure you want to delete ${this.payload.filters[filterIndex].name} ${this.payload.resourceTitle.toLowerCase()}?`, 'Confirm', 'Cancel'),
      ModalTypes.ALERT
    ).pipe(
      map(res => res.payload),
      flatMap((res: modalResponse) => {
        switch (res) {
          case modalResponse.approve:
            return this.filterService.deleteFilter(this.payload.filters[filterIndex].id);
          default:
            return Observable.empty();
        }
      })
    )
    .subscribe(
      () => {
        this.filterAC.deleteAppliedFilter(this.payload.filters[filterIndex].id);

        if (this.callback) {
          this.callback(this.payload.filters[filterIndex].id, true);
        }

        this.payload.filters.splice(filterIndex);
        this.notificationMessageService.success(`${this.payload.resourceTitle} ${this.notificationMessage.DELETED_SUCCESSFULLY}`);
      },
      () => {
        this.notificationMessageService.error(`${this.notificationMessage.ERROR_DELETING} ${this.payload.resourceTitle.toLowerCase()} !`);
      },
      () => this.changeDetector.markForCheck()
    );
  }

  beforeClose() {
    this.callback(this.selectedFilter);
  }

}
